import React from 'react'
import { useEffect, useState } from 'react'
import { ReservationF } from '../../../../types/reservation-detail.types'
import { FormControlLabel, Radio, RadioGroup, Stack, Grid, Divider, Typography } from '@vapor/material'
import BillLookup from 'src/app/pages/booking/bill/components/BillLookup'
import { useRequiredProperty } from 'src/app/hooks/context/context.hook'
import { useTranslation } from 'react-i18next'
import { BillCategoryType } from 'src/api/api.generated'
import { HicChip } from 'src/app/components/hic-chip/hic-chip'
import { faBed, faUser } from '@fortawesome/pro-solid-svg-icons'
import { UnionBill } from './production-assigned-actions.type'

type SelectReservationDestinationBillProps = {
  bills: UnionBill[]
  setDestinationBillId: (billId: string | null) => void
  reservationId: string[]
  reservedResourceId?: string[]
  defaultNewBillCategory?: BillCategoryType
  reservation?: ReservationF
  sourceBillId?: string
}

export const SelectReservationDestinationBill = ({
  bills,
  setDestinationBillId,
  reservationId,
  reservedResourceId,
  defaultNewBillCategory,
  reservation,
  sourceBillId,
}: SelectReservationDestinationBillProps) => {
  const { t } = useTranslation()
  const propertyId = useRequiredProperty().id

  const [localSelectedBill, setLocalSelectedBill] = useState<string | null>(bills[0]?.id || 'NEW')

  useEffect(() => {
    if (localSelectedBill) {
      setDestinationBillId(localSelectedBill !== 'NEW' ? localSelectedBill : null)
    }
  }, [localSelectedBill])

  return (
    <Stack>
      <RadioGroup onChange={(e) => setLocalSelectedBill(e.target.value)} defaultValue={bills[0]?.id || 'NEW'}>
        {bills.map((b, index) => (
          <React.Fragment key={index}>
            <FormControlLabel
              key={index}
              value={b.id}
              control={<Radio />}
              label={
                <Stack>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body">
                      <b>{b.description}</b>
                    </Typography>
                    <Typography variant="body">{b.searchInfo.ownerName}</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1}>
                    <HicChip text={b.category} color="var(--QuickSilver)" variant="light" />
                    {b.searchInfo.guestNames?.map((g, i) => {
                      return <HicChip key={i} icon={faUser} text={g} color="var(--QuickSilver)" variant="light" />
                    })}
                    {b.searchInfo.resources?.map((r, i) => {
                      return <HicChip key={i} icon={faBed} text={r} color="var(--QuickSilver)" variant="light" />
                    })}
                  </Stack>
                </Stack>
              }
            />
            <Divider light />
          </React.Fragment>
        ))}
        <FormControlLabel value={'NEW'} control={<Radio />} label={t('pms.booking.reservation.productions_assigned.action.move.another_bill')} />
      </RadioGroup>
      {localSelectedBill === 'NEW' || (localSelectedBill && !bills.map((b) => b.id).includes(localSelectedBill)) ? (
        <Grid container sx={{ width: '100%' }}>
          <Grid item xs={12}>
            <BillLookup
              propertyId={propertyId}
              value={{ id: localSelectedBill }}
              onChange={(value) => {
                setLocalSelectedBill(value?.id ?? null)
              }}
              reservationIds={reservationId}
              reservedResourceIds={reservedResourceId}
              defaultNewBillCategory={defaultNewBillCategory}
              reservation={reservation}
              billIdExcludedFromResult={sourceBillId}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Stack>
  )
}
